// src/SfbContext.js   -> Students Fee Balance
import React, { createContext, useContext, useState, useEffect } from 'react';
import config from '../config';


const SfbContext = createContext();

export function SfbProvider({ children }) {
  const [sfb, setSfb] = useState([]);
  const [sfbloading, setSfbLoading] = useState(false);

  
  const fetchData = async () => {
    try {
      setSfbLoading(true);
      const response = await fetch(`${config.apiBaseUrl}/payments/getBalances.php`);//Peroduction
      const data = await response.json();
      setSfb(data);
    } catch (error) {
      console.error('Error fetching fee sfb data:', error);
    } finally {
      setSfbLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const refetchSfbData = () => {
    fetchData();
  };

  console.log(sfb);

  return (
    <SfbContext.Provider value={{ sfb, sfbloading, refetchSfbData }}>
      {children}
    </SfbContext.Provider>
  );
}

export function useSfb() {
  const context = useContext(SfbContext);
  if (context === undefined) {
    throw new Error('useSfb must be used within a SfbProvider');
  }
  return context;
}
